/**
 * Enhances the sticky-atc component with image and variant title updates
 */
(function() {
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtcEnhancer);
  } else {
    initStickyAtcEnhancer();
  }

  function initStickyAtcEnhancer() {
    console.log('Initializing Sticky ATC Enhancer');
    const stickyAtcElements = document.querySelectorAll('sticky-atc');
    console.log('Found sticky-atc elements:', stickyAtcElements.length);
    if (stickyAtcElements.length === 0) return;

    // Initialize each sticky-atc element
    stickyAtcElements.forEach(stickyAtc => {
      // Skip if already initialized
      if (stickyAtc.dataset.enhanced === 'true') return;
      stickyAtc.dataset.enhanced = 'true';

      // Set up elements
      const section = stickyAtc.closest('.section-main-product') || document.querySelector('.product-detail');
      console.log('Found section:', section ? true : false);
      
      const imageContainer = stickyAtc.querySelector('.sticky-atc__image');
      console.log('Found image container:', imageContainer ? true : false);
      
      const variantContainer = stickyAtc.querySelector('.sticky-atc__details__variant');
      console.log('Found variant container:', variantContainer ? true : false);
      
      const variantTitle = stickyAtc.querySelector('.sticky-atc__details__variant__title');
      console.log('Found variant title:', variantTitle ? true : false);
      
      // Add error container reference
      const errorContainer = stickyAtc.querySelector('.sticky-atc__error');
      console.log('Found error container:', errorContainer ? true : false);
      
      // Force show the variant container and title
      if (variantContainer) {
        variantContainer.style.display = 'flex';
        variantContainer.hidden = false;
        variantContainer.removeAttribute('hidden');
      }
      
      if (variantTitle) {
        variantTitle.style.display = 'inline';
        variantTitle.hidden = false;
        variantTitle.removeAttribute('hidden');
      }

      // Function to show error message
      function showError(message) {
        if (!errorContainer) return;
        
        errorContainer.textContent = message;
        errorContainer.hidden = false;
        stickyAtc.classList.add('sticky-atc--error');
        
        // Auto-hide after 5 seconds
        setTimeout(() => {
          clearError();
        }, 5000);
      }
      
      // Function to clear error message
      function clearError() {
        if (!errorContainer) return;
        
        errorContainer.textContent = '';
        errorContainer.hidden = true;
        stickyAtc.classList.remove('sticky-atc--error');
      }

      // Function to update the image
      function updateImage() {
        if (!imageContainer) return;
        
        // Try different selectors to find the main product image
        const selectors = [
          '.main-image .slide.is-active img',
          '.main-image .slide.slide--custom-initial img',
          '.main-image .slide:first-child img',
          '.main-image img'
        ];
        
        let mainImage = null;
        let usedSelector = '';
        
        for (const selector of selectors) {
          mainImage = section?.querySelector(selector);
          if (mainImage) {
            usedSelector = selector;
            break;
          }
        }
        
        console.log('Found main image:', mainImage ? true : false, 'using selector:', usedSelector);
        
        if (mainImage) {
          // Clone the image to avoid moving it from its original location
          const imgClone = mainImage.cloneNode(true);
          imageContainer.innerHTML = '';
          imageContainer.appendChild(imgClone);
          console.log('Image updated successfully');
        }
      }

      // Function to get the current variant title from all selected options
      function getCurrentVariantTitle() {
        const selectedOptions = [];
        
        // First try clickyboxes (your theme's custom selector)
        const clickyboxes = document.querySelectorAll('.clickyboxes');
        clickyboxes.forEach(box => {
          const activeOption = box.querySelector('.active');
          if (activeOption) {
            selectedOptions.push(activeOption.textContent.trim());
          }
        });
        
        // If no clickyboxes found or no active options, try select elements
        if (selectedOptions.length === 0 || selectedOptions.length < clickyboxes.length) {
          const selects = document.querySelectorAll('[data-single-option-selector]');
          selects.forEach(select => {
            if (select.selectedOptions && select.selectedOptions.length > 0) {
              // Only add if we don't already have this option position
              const optionIndex = parseInt(select.getAttribute('data-index').replace('option', '')) - 1;
              if (!selectedOptions[optionIndex]) {
                selectedOptions[optionIndex] = select.selectedOptions[0].textContent.trim();
              }
            }
          });
        }
        
        // Clean up any undefined entries
        const cleanOptions = selectedOptions.filter(opt => opt);
        console.log('Current selected options:', cleanOptions);
        
        return cleanOptions.join(' / ');
      }

      // Function to update the button text based on variant availability
      function updateButtonText(variant) {
        const addToCartButton = stickyAtc.querySelector('.add-to-cart');
        console.log('updateButtonText called with variant:', variant);
        console.log('Found button:', addToCartButton ? true : false);
        
        if (!addToCartButton) return;
        
        console.log('Current button text:', addToCartButton.textContent);
        console.log('Button data attributes:', {
          unavailableText: addToCartButton.dataset.unavailableText,
          addToCartText: addToCartButton.dataset.addToCartText
        });
        
        if (!variant) {
          // No variant selected
          const newText = addToCartButton.dataset.unavailableText || 'View Details';
          console.log('No variant selected, setting text to:', newText);
          addToCartButton.textContent = newText;
          return;
        }
        
        if (variant.available) {
          // Variant is available
          const newText = addToCartButton.dataset.addToCartText || 'Add to Cart';
          console.log('Variant is available, setting text to:', newText);
          addToCartButton.textContent = newText;
        } else {
          // Variant is unavailable
          console.log('Variant is unavailable, setting text to: Sold Out');
          addToCartButton.textContent = 'Sold Out';
        }
        
        console.log('Updated button text for variant:', variant.title, 'Available:', variant.available, 'New text:', addToCartButton.textContent);
      }

      // Function to update variant title
      function updateVariantTitle() {
        console.log('updateVariantTitle called');
        if (!variantTitle) {
          console.log('No variant title element found');
          return;
        }
        
        const newTitle = getCurrentVariantTitle();
        console.log('Setting variant title to:', newTitle);
        
        if (newTitle) {
          variantTitle.textContent = newTitle;
          variantTitle.style.display = 'inline';
          variantTitle.hidden = false;
          variantTitle.removeAttribute('hidden');
          
          if (variantContainer) {
            variantContainer.style.display = 'block';
            variantContainer.hidden = false;
            variantContainer.removeAttribute('hidden');
          }
          
          // Update the variant ID in the form
          const idInput = stickyAtc.querySelector('input[name="id"]');
          console.log('Found ID input:', idInput ? true : false);
          
          if (idInput) {
            const mainForm = section.querySelector('form[action*="/cart/add"]');
            console.log('Found main form:', mainForm ? true : false);
            
            if (mainForm) {
              const mainIdInput = mainForm.querySelector('input[name="id"]');
              console.log('Found main ID input:', mainIdInput ? true : false, mainIdInput ? mainIdInput.value : 'no value');
              
              if (mainIdInput && mainIdInput.value) {
                idInput.value = mainIdInput.value;
                console.log('Updated variant ID to:', mainIdInput.value);
                
                // Get the current variant to check availability
                const productJSON = getProductJSON();
                if (productJSON && productJSON.variants) {
                  console.log('Looking for variant with ID:', mainIdInput.value);
                  const currentVariant = productJSON.variants.find(v => v.id.toString() === mainIdInput.value.toString());
                  console.log('Found current variant:', currentVariant ? true : false);
                  
                  if (currentVariant) {
                    console.log('Calling updateButtonText with variant:', currentVariant.title, 'Available:', currentVariant.available);
                    updateButtonText(currentVariant);
                  } else {
                    console.log('Current variant not found in product JSON');
                  }
                } else {
                  console.log('No product JSON or variants found');
                }
              }
            }
          }
        }
      }
      
      // Helper function to get product JSON
      function getProductJSON() {
        // First try to get product ID from the sticky-atc element
        let productId = stickyAtc.dataset.productId;
        console.log('Sticky ATC product ID:', productId);
        
        // If not found, try to get it from the main product section
        if (!productId) {
          const mainProductSection = document.querySelector('[data-section-type="main-product"]');
          if (mainProductSection) {
            productId = mainProductSection.dataset.productId;
            console.log('Found product ID from main section:', productId);
          }
        }
        
        if (!productId) {
          console.log('No product ID found in any element');
          return null;
        }
        
        // Try multiple ways to get product data
        const productJSONElement = document.getElementById(`ProductJson-${productId}`);
        console.log('Looking for ProductJson element with ID:', `ProductJson-${productId}`);
        console.log('Found ProductJson element:', productJSONElement ? true : false);
        
        if (productJSONElement) {
          try {
            const productData = JSON.parse(productJSONElement.innerHTML);
            console.log('Successfully parsed product JSON with', productData.variants?.length || 0, 'variants');
            return productData;
          } catch (e) {
            console.error('Error parsing product JSON:', e);
          }
        }
        
        // Try other methods if the first one failed
        const themeProductData = window.theme && window.theme.productData && window.theme.productData[productId];
        const sectionProductData = document.getElementById(`ProductJson-${section?.dataset?.section}`);
        
        return themeProductData || 
               (sectionProductData ? JSON.parse(sectionProductData.innerHTML) : null);
      }
      
      // Set up event listeners for variant changes
      function setupVariantChangeListeners() {
        // 1. Listen for clicks on clickyboxes
        document.addEventListener('click', function(e) {
          const clickybox = e.target.closest('.clickyboxes a');
          if (clickybox) {
            console.log('Clickybox clicked:', clickybox.textContent.trim());
            // Wait a moment for the clickybox to update
            setTimeout(function() {
              updateVariantTitle();
              updateImage();
            }, 100);
          }
        });
        
        // 2. Listen for changes on select elements
        const selects = document.querySelectorAll('[data-single-option-selector]');
        selects.forEach(select => {
          select.addEventListener('change', function() {
            console.log('Select changed:', this.value);
            setTimeout(function() {
              updateVariantTitle();
              updateImage();
            }, 100);
          });
        });
        
        // 3. Listen for custom events that might be dispatched by the theme
        const eventTypes = [
          'variant:changed', 
          'variantChanged',
          'variant_changed',
          'on:variant:change'
        ];
        
        eventTypes.forEach(eventType => {
          section.addEventListener(eventType, function(e) {
            console.log(`${eventType} event detected`);
            setTimeout(function() {
              updateVariantTitle();
              updateImage();
            }, 100);
          });
        });
        
        // 4. Watch for changes to the main product form's variant ID
        const mainForm = section.querySelector('form[action*="/cart/add"]');
        if (mainForm) {
          const mainIdInput = mainForm.querySelector('input[name="id"]');
          if (mainIdInput) {
            const inputObserver = new MutationObserver((mutations) => {
              for (const mutation of mutations) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                  console.log('Main form variant ID changed');
                  setTimeout(function() {
                    updateVariantTitle();
                    updateImage();
                  }, 100);
                }
              }
            });
            
            inputObserver.observe(mainIdInput, { attributes: true });
          }
        }
      }
      
      // Create a MutationObserver to watch for changes to the active slide
      function setupSlideObserver() {
        const slideObserver = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (mutation.type === 'attributes' && 
                (mutation.attributeName === 'class' || mutation.attributeName === 'aria-hidden')) {
              console.log('Slide changed, updating image');
              setTimeout(updateImage, 100);
            }
          }
        });
        
        // Observe all slides for class changes
        const slides = section?.querySelectorAll('.slide, .slider__item');
        if (slides && slides.length > 0) {
          slides.forEach(slide => {
            slideObserver.observe(slide, { attributes: true });
          });
          console.log(`Observing ${slides.length} slides for changes`);
        }
      }
      
      // Set up form submission handler for error display
      function setupFormErrorHandling() {
        const form = stickyAtc.querySelector('form');
        if (!form) return;
        
        // Listen for errors from the sticky-atc.js component
        stickyAtc.addEventListener('error', function(e) {
          if (e.detail && e.detail.message) {
            showError(e.detail.message);
          }
        });
        
        // Also patch the fetch API to catch errors
        const originalFetch = window.fetch;
        window.fetch = async function(...args) {
          try {
            // Check if this is a cart/add request
            if (args[0] && typeof args[0] === 'string' && args[0].includes('/cart/add')) {
              const response = await originalFetch.apply(this, args);
              
              // If the response is not ok, try to extract the error message
              if (!response.ok) {
                const clonedResponse = response.clone();
                try {
                  const errorData = await clonedResponse.json();
                  if (errorData && (errorData.description || errorData.message)) {
                    // Show the error message
                    showError(errorData.description || errorData.message);
                    
                    // Dispatch an error event that the original component might be listening for
                    const errorEvent = new CustomEvent('sticky-atc:error', { 
                      bubbles: true,
                      detail: errorData
                    });
                    stickyAtc.dispatchEvent(errorEvent);
                  }
                } catch (err) {
                  console.error('Error parsing response:', err);
                }
              }
              
              return response;
            }
            
            // For non-cart requests, just use the original fetch
            return originalFetch.apply(this, args);
          } catch (error) {
            console.error('Fetch error:', error);
            throw error;
          }
        };
      }
      
      // Also add direct variant change listeners to update button text
      function setupDirectVariantChangeListeners() {
        console.log('Setting up direct variant change listeners');
        
        // Listen for variant change events from the main product form
        const mainForm = section.querySelector('form[action*="/cart/add"]');
        if (mainForm) {
          console.log('Found main form for direct listeners');
          
          // Listen for changes to the variant ID input
          const mainIdInput = mainForm.querySelector('input[name="id"]');
          if (mainIdInput) {
            console.log('Setting up observer for main ID input');
            
            // Create a MutationObserver to watch for value changes
            const observer = new MutationObserver((mutations) => {
              for (const mutation of mutations) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                  console.log('Main ID input value changed to:', mainIdInput.value);
                  
                  // Get the current variant
                  const productJSON = getProductJSON();
                  if (productJSON && productJSON.variants) {
                    const currentVariant = productJSON.variants.find(v => v.id.toString() === mainIdInput.value.toString());
                    if (currentVariant) {
                      console.log('Directly updating button text for variant change');
                      updateButtonText(currentVariant);
                    }
                  }
                }
              }
            });
            
            observer.observe(mainIdInput, { attributes: true });
          }
          
          // Also listen for variant:changed events
          section.addEventListener('variant:changed', function(e) {
            console.log('variant:changed event detected', e.detail);
            if (e.detail && e.detail.variant) {
              console.log('Updating button text from variant:changed event');
              updateButtonText(e.detail.variant);
            }
          });
        }
      }
      
      // Initial setup
      updateImage();
      updateVariantTitle();
      setupVariantChangeListeners();
      setupDirectVariantChangeListeners();
      setupSlideObserver();
      setupFormErrorHandling();
      
      // Log success
      console.log('Sticky ATC enhancer initialized successfully');
    });
  }
  
  // Also listen for dynamic content changes that might add sticky-atc elements
  if ('MutationObserver' in window) {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.matches('sticky-atc') || node.querySelector('sticky-atc')) {
                initStickyAtcEnhancer();
                break;
              }
            }
          }
        }
      }
    });
    
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });
  }
})(); 